import {
  Button,
  Dialog,
  DialogContent,
  Fade,
  Grid,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import React, { forwardRef } from "react";

const Transition = forwardRef(function Transition(props, ref) {
  return <Fade ref={ref} {...props} />;
});

function ConfirmBox({ open, closeDialog, deleteFunction,title,err}) {
  return (
    <Dialog   
      open={open}
      maxWidth="md"
      scroll="body"
      onClose={closeDialog}
      onBackdropClick={closeDialog}
      TransitionComponent={Transition}
    >
      <DialogContent sx={{ px: 0, py: 2, position: "relative" }}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Box
              sx={{
                mb: 1,
                display: "flex",
                justifyContent: "flex-start",
                flexDirection: "column",
              }}
            >
              <Typography variant="body1" align="center">
                Are you sure you want to delete this ?
              </Typography>
              <br/>
              <Typography align="center" variant="h3">{title}</Typography>
            </Box>
          </Grid>
          <Grid
            item
            xs={12}
            sx={{ display: "flex", justifyContent: "center", gap: "1rem" }}
          >
            <Button onClick={closeDialog} size="medium" variant="contained" color="primary">
              Cancel
            </Button>
            <Button onClick={deleteFunction} size="medium" variant="contained" color="error">
              Delete
            </Button>{" "}
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
}

export default ConfirmBox;
